import React from "react";
import { arrayOf, number, shape, string } from "prop-types";
import { Card } from "uikit/components";
import styles from "./RegionSchoolsAttendanceView.module.styl";
import RegionSchoolsAttendanceRow from "components/regionSummary/RegionSchoolsAttendanceRow/RegionSchoolsAttendanceRow";

export default function RegionSchoolsAttendanceView({ regionId, schoolsAttendance }) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
            <div className={styles.headingContainer} data-test-name="region_attendance_form">
                <div className={styles.schoolName}>Название организации</div>
                <div className={styles.municipalityName}>Район / Населённый пункт</div>
                <div className={styles.attendancePercent}>Посещаемость за прошлую неделю</div>
            </div>
            <div>
                {schoolsAttendance?.map((item) => (
                    <RegionSchoolsAttendanceRow
                        key={item.schoolId}
                        schoolAttendance={item}
                        regionId={regionId}
                    />
                )) ?? []}
            </div>
        </Card>
    );
}

RegionSchoolsAttendanceView.propTypes = {
    regionId: number.isRequired,
    schoolsAttendance: arrayOf(
        shape({
            schoolId: number.isRequired,
            schoolName: string.isRequired,
            municipalityName: string,
            attendancePercent: number.isRequired,
        }),
    ),
};
